import React from 'react';

function ContactInfo() {
  return (
    <section className="tc-contact-info-style1">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="info-cards">
              <div className="row">
                <div className="col-lg-6">
                  <div className="item mt-50">
                    <h6 className="fsz-24 mb-15 fw-bold"> Chennai, TN </h6>
                    <ul className="color-666 lh-6">
                      <li>
                        <a href="tel:+91 87545 05413"> 1st Main, Madurai Manavalan Nagar, Pooniammanmedu,  – 600110 </a>
                      </li>
                      <li>
                        <a href="mailto:operations@artisanguildinfra.com"> operations@artisanguildinfra.com</a>
                      </li>
                      <li>
                        <a href="tel:+91 87545 05413"> +91 87545 05413 </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="item mt-50">
                    <h6 className="fsz-24 mb-15 fw-bold"> Kozhikode, Kerala </h6>
                    <ul className="color-666 lh-6">
                      <li>
                        <a href="">Karaparamba, Malikadavu Road, Kozhikode – 673010</a>
                      </li>
                      <li>
                        <a href="mailto:operations@artisanguildinfra.com"> operations@artisanguildinfra.com </a>
                      </li>
                      <li>
                        <a href="#"> +91 87545 05413 </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
             <div className="item mt-50">
                    <h6 className="fsz-24 mb-15 fw-bold"> Fabrication Unit</h6>
                    <ul className="color-666 lh-6">
                      <li>
                        <a href="">Kunnathur, Coimbatore, Tamil Nadu - 641110</a>
                      </li>
                      <li>
                        <a href="mailto:operations@artisanguildinfra.com"> operations@artisanguildinfra.com </a>
                      </li>
                      <li>
                        <a href="tel:+91 87545 05413"> +91 87545 05413 </a>
                      </li>
                    </ul>
                  </div>
          </div>
        </div>
        <div className="social-icons mt-50 text-lg-end">
              <a href="#">
                <i className="fab fa-x-twitter"></i>
              </a>
              <a href="#">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://www.instagram.com/artisanguildinfra?igsh=c2FlYzFvY3lrZnRu">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="#">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
      </div>
    </section>
  );
}

export default ContactInfo;
